export const emptyCommandBarResult = {
    actions: [],
    isLoading: false,
};
//# sourceMappingURL=types.js.map